(function () {
  if (window.__unlimitedProductBundlesCollapseInit) return;
  window.__unlimitedProductBundlesCollapseInit = true;

  var APP_BLOCK_SELECTOR = '.mpgGeneral__block--app';
  var ROOT_SELECTOR = '#rbu-mpb';
  var PRODUCTS_SELECTOR = '.rbu-mpb-products';
  var ITEM_SELECTOR = '.rbu-mpb-products__product-detail-container';
  var TOTALS_SELECTOR = '.rbu-mpb-totals';
  var TOGGLE_SELECTOR = '[data-rbu-mpb-toggle]';
  var COLLAPSE_AFTER = 2;

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function updateToggleState(toggle, isExpanded) {
    if (!toggle) return;

    var expandedValue = isExpanded ? 'true' : 'false';
    if (toggle.getAttribute('aria-expanded') !== expandedValue) {
      toggle.setAttribute('aria-expanded', expandedValue);
    }

    var textElement = toggle.querySelector('.rbuMpbToggle__text');
    var nextText = isExpanded ? 'View Less' : 'View All';
    if (textElement && textElement.textContent !== nextText) {
      textElement.textContent = nextText;
    }
  }

  function getEntries(productsElement) {
    return toArray(productsElement.querySelectorAll(ITEM_SELECTOR))
      .map(function (itemElement) {
        var wrapperElement = itemElement.parentElement && itemElement.parentElement !== productsElement
          ? itemElement.parentElement
          : itemElement;

        return {
          wrapper: wrapperElement
        };
      })
      .filter(function (entry, index, entries) {
        return entries.findIndex(function (candidate) {
          return candidate.wrapper === entry.wrapper;
        }) === index;
      });
  }

  function ensureToggle(rootElement, productsElement) {
    var toggle = rootElement.querySelector(TOGGLE_SELECTOR);
    if (toggle) return toggle;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'rbuMpbToggle';
    toggle.setAttribute('data-rbu-mpb-toggle', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<span class="rbuMpbToggle__text">View All</span>' +
      '<span class="rbuMpbToggle__icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">' +
      '<path d="M22.6667 13.3334L16 20L9.33335 13.3334" stroke="#0BB3FB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>';

    toggle.addEventListener('click', function () {
      var isExpanded = productsElement.classList.contains('is-rbu-expanded');
      productsElement.classList.toggle('is-rbu-expanded', !isExpanded);
      productsElement.classList.toggle('is-rbu-collapsed', isExpanded);
      updateToggleState(toggle, !isExpanded);
    });

    var totalsElement = rootElement.querySelector(TOTALS_SELECTOR);
    if (totalsElement) {
      totalsElement.insertAdjacentElement('beforebegin', toggle);
    } else {
      productsElement.appendChild(toggle);
    }

    return toggle;
  }

  function updateRoot(rootElement) {
    var productsElement = rootElement.querySelector(PRODUCTS_SELECTOR);
    if (!productsElement) return;

    var entries = getEntries(productsElement);
    var toggle = rootElement.querySelector(TOGGLE_SELECTOR);

    entries.forEach(function (entry, index) {
      entry.wrapper.classList.add('rbuMpbProductsEntry');
      entry.wrapper.classList.toggle('is-rbu-collapsed-item', index >= COLLAPSE_AFTER);
    });

    if (entries.length <= COLLAPSE_AFTER) {
      productsElement.classList.remove('is-rbu-collapsible', 'is-rbu-collapsed', 'is-rbu-expanded');
      if (toggle) toggle.remove();
      return;
    }

    productsElement.classList.add('is-rbu-collapsible');
    if (!productsElement.classList.contains('is-rbu-expanded')) {
      productsElement.classList.add('is-rbu-collapsed');
    }

    toggle = ensureToggle(rootElement, productsElement);
    updateToggleState(toggle, productsElement.classList.contains('is-rbu-expanded'));
  }

  function scan(scope) {
    var root = scope || document;

    if (root.matches && root.matches(ROOT_SELECTOR)) {
      bindRoot(root);
      updateRoot(root);
      return;
    }

    toArray(root.querySelectorAll(ROOT_SELECTOR)).forEach(function (rootElement) {
      bindRoot(rootElement);
      updateRoot(rootElement);
    });
  }

  function scheduleScan(scope) {
    var root = scope || document;
    if (root.__rbuMpbScanScheduled) return;

    root.__rbuMpbScanScheduled = true;
    window.requestAnimationFrame(function () {
      root.__rbuMpbScanScheduled = false;
      scan(root);
    });
  }

  function nodeMatchesRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(TOGGLE_SELECTOR)) return false;

    return Boolean(
      (node.matches && node.matches(ROOT_SELECTOR + ', ' + PRODUCTS_SELECTOR + ', ' + ITEM_SELECTOR + ', ' + TOTALS_SELECTOR)) ||
      (node.querySelector && node.querySelector(ROOT_SELECTOR + ', ' + PRODUCTS_SELECTOR + ', ' + ITEM_SELECTOR + ', ' + TOTALS_SELECTOR))
    );
  }

  function hasRelevantMutation(mutationList) {
    return mutationList.some(function (mutation) {
      if (!mutation.target || !mutation.target.closest || mutation.target.closest(TOGGLE_SELECTOR)) {
        return false;
      }

      return toArray(mutation.addedNodes).some(nodeMatchesRelevant) || toArray(mutation.removedNodes).some(nodeMatchesRelevant);
    });
  }

  function hasRootMutation(mutationList) {
    return mutationList.some(function (mutation) {
      return toArray(mutation.addedNodes).some(function (node) {
        if (!node || node.nodeType !== 1) return false;

        return Boolean(
          (node.matches && node.matches(ROOT_SELECTOR)) ||
          (node.querySelector && node.querySelector(ROOT_SELECTOR))
        );
      });
    });
  }

  function bindRoot(rootElement) {
    if (!rootElement || rootElement.__rbuMpbObserverBound) return;

    rootElement.__rbuMpbObserverBound = true;
    updateRoot(rootElement);

    var observer = new MutationObserver(function (mutationList) {
      if (!hasRelevantMutation(mutationList)) return;
      scheduleScan(rootElement);
    });

    observer.observe(rootElement, {
      childList: true,
      subtree: true
    });

    rootElement.__rbuMpbObserver = observer;
  }

  function bindAppBlock(appBlock) {
    if (!appBlock || appBlock.__rbuMpbAppObserverBound) return;

    appBlock.__rbuMpbAppObserverBound = true;
    scan(appBlock);

    var observer = new MutationObserver(function (mutationList) {
      if (!hasRootMutation(mutationList)) return;
      scheduleScan(appBlock);
    });

    observer.observe(appBlock, {
      childList: true,
      subtree: true
    });

    appBlock.__rbuMpbAppObserver = observer;
  }

  function init() {
    toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(bindRoot);
    toArray(document.querySelectorAll(APP_BLOCK_SELECTOR)).forEach(bindAppBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
